<template>
    <div>
        <acceptTask :task-data="taskData" data-type="review_task" @jumpToSubmit="jumpToSubmit"/>
    </div>
</template>

<script>
    import acceptTask from "../../components/task/acceptTask";
    import {getJobList} from "../../api/translator";

    export default {
        name: "accept",
        components:{acceptTask},
        data(){
            return{
                taskData: [],
                offset : 0,
            }
        },
        methods:{
            jumpToSubmit(){
                this.$router.push('/review_task/submit')
            },
            // refreshCurrentPage(){
            //     this.offset -= 1;
            //     this.getJobListEvent(this.offset)
            // },
            async getJobListEvent(offset){
                await getJobList(offset, 'review')
                    .then(data=>{
                        this.taskData = data.results;
                        this.total = data.total;
                        this.offset += 1;
                    })
                    .catch(error=>{
                        console.log(error)
                    })
            }
        },
        created() {
            this.getJobListEvent(this.offset)
        }

    }
</script>

<style scoped lang="scss">

</style>